"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../../../styles/theme"));
const businessShareholderCardStyles_1 = __importDefault(require("./businessShareholderCardStyles"));
const icon_1 = __importStar(require("../../../../components/icon/icon"));
const touchableElement_1 = __importDefault(require("../../../../components/pressables/touchableElement"));
const styles_1 = __importDefault(require("../../../../styles/styles"));
const text_1 = __importStar(require("../../../../components/text/text"));
const BusinessShareholderCard = ({ businessShareholder, deleteShareholder, editShareholder, }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexThree, styles_1.default.flexDirectionColumn] },
        react_1.default.createElement(react_native_1.View, { style: [businessShareholderCardStyles_1.default.cardBackground, { borderWidth: 0.3, borderColor: theme_1.default.colors.COLOR_GRAY_LIGHT }] },
            react_1.default.createElement(touchableElement_1.default, { onPress: editShareholder, eventName: "edit_business_shareholder" },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionColumn },
                    react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.mainContainerPadding,
                            styles_1.default.minimumMarginBetweenElementsVertically,
                        ] },
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: businessShareholderCardStyles_1.default.accountNumberText }, `ROLE: ${businessShareholder.roles}`),
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: businessShareholderCardStyles_1.default.accountNumberText }, `${businessShareholder.first_name} ${businessShareholder.last_name}`),
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: businessShareholderCardStyles_1.default.accountNumberText }, `${businessShareholder.email}`)))),
            react_1.default.createElement(touchableElement_1.default, { style: [
                    businessShareholderCardStyles_1.default.cardDeleteBackground,
                    styles_1.default.flexOne,
                    { backgroundColor: theme_1.default.colors.COLOR_UNDERLINE_GRAY, paddingVertical: 8 },
                ], onPress: () => deleteShareholder(businessShareholder.user_id), eventName: "tap_shareholder_delete" },
                react_1.default.createElement(icon_1.default, { name: icon_1.TRASH_ICON, fill: theme_1.default.colors.COLOR_CRITICAL })))));
};
exports.default = BusinessShareholderCard;
